import { ModelBase } from 'store/model-base';

export class CmsInternationalCalling extends ModelBase {
    public static storeName: string = 'cmsInternationalCalling';

    public backToBreadCrumb: CmsBackToBreadCrumb;
    public pageHeader: string;
    public pageDescription: string;
    public searchBoxLabel: string;
    public searchBoxPlaceholder: string;
    public initialSearchData: CmsSearchData;
    public maxCanInActiveData: CmsSearchData;
    public maxCanActiveData: CmsSearchData;
    public otherCountryData: CmsSearchData;
    public blackListedCountryData: CmsSearchData;
    public talkData: TalkMsgData;
    public msgData: TalkMsgData;
    public notFoundIcon: CmsMediaImage;
    public notFoundDisclaimer: string;
    public cta: string;
    public callRatesReaderText: string;
}
